import Link from 'next/link';
import { useTranslations } from 'next-intl';

import { UiKitButtonBase } from '@/fo/ui/kit/button/base';
import { utilFormatPhoneNumber } from '@/fo/util/format-phone-number';

import { PointFeature } from '../../types';

import { styles } from './PointInfo.styles';
export interface PointInfoProps {
  point: PointFeature;
  selectedCity?: string;
}

export function PointInfo({ point, selectedCity }: PointInfoProps) {
  const t = useTranslations();
  const mapLink = `http://maps.yandex.ru/?pt=${point.geometry.coordinates[0]},${point.geometry.coordinates[1]}&z=18&l=map`;
  const slots = styles();
  return (
    <>
      <p className={slots.title()}>{point.properties.title}</p>
      <p className={slots.address()}>{point.properties.address}</p>
      {point.properties.work_time && (
        <p className={slots.worktime()}>{point.properties.work_time}</p>
      )}
      <Link
        className={slots.phone()}
        href={`tel:${point.properties.phone}`}
      >
        {utilFormatPhoneNumber(point.properties.phone || '')}
      </Link>
      {!selectedCity && (
        <UiKitButtonBase
          color="secondary"
          as="link"
          href={mapLink}
          target="_blank"
          className={slots.button()}
        >
          {t('Get direction')}
        </UiKitButtonBase>
      )}
      {selectedCity && <p className={slots.stock()}>{t('In stock')}</p>}
    </>
  );
}
